jQuery(document).ready(function () {
  var mqMd = window.matchMedia('(min-width: 768px) and (max-width: 991px)');
  var mqLg = window.matchMedia('(min-width: 992px)');

  if (mqMd.matches) {
    var topDistance = -60; //console.log(topDistance);
  } else {
    var topDistance = -60; // console.log(topDistance);
  }

  if (jQuery('.c-fixed-at-top')[0]) {
    var distance = jQuery('.c-fixed-at-top').offset().top + topDistance,
        $window = jQuery(window);
    $window.scroll(function () {
      // Hide side CTA when reaching main cta
      var ctaBlockSideHeight = jQuery('.js-cta-block-side').height();
      var ctaBlockSidePosition = jQuery('.js-cta-block-side').offset().top;
      var ctaBlockMainPosition = jQuery('.js-cta-block-main').offset().top; // console.log('ctaBlockSideHeight  :' + ctaBlockSideHeight);
      // console.log('ctaBlockSidePosition  :' + ctaBlockSidePosition);
      // console.log('ctaBlockMainPosition  :' + ctaBlockMainPosition);

      if (ctaBlockSidePosition + ctaBlockSideHeight - 200 > ctaBlockMainPosition) {
        jQuery('.js-cta-block-side').addClass('hideme');
      } else {
        jQuery('.js-cta-block-side').removeClass('hideme');
      }

      if ($window.scrollTop() >= distance) {
        //console.log('Distance :' + distance);
        jQuery('.c-fixed-at-top').addClass('active');
      } else {
        jQuery('.c-fixed-at-top').removeClass('active');
      }

      jQuery('.c-fixed-at-top').each(function () {
        var fixed = jQuery(this);
        var fixed_position = jQuery(this).offset().top;
        var fixed_height = jQuery(this).height(); // console.log('Fixed position : ' + fixed_position);
        // console.log('Fixed height : ' + fixed_height);

        var toCross_position = jQuery('.c-fixed-at-top__marker').offset().top;
        var toCross_height = jQuery('.c-fixed-at-top__marker').height(); // console.log('Marker position : ' + toCross_position);
        // console.log('Marker height : ' + toCross_height);

        if (fixed_position + fixed_height > toCross_position) {
          fixed.addClass('at-bottom').removeClass('active');
        }

        var distanceTwo = jQuery(this).offset().top - jQuery(document).scrollTop(); //console.log('SNAP!!!!!!' + distanceTwo);

        if (mqMd.matches) {
          var topDistance = 60;
        } else {
          var topDistance = 160;
        }

        if (distanceTwo > topDistance) {
          //console.log('Magic!!!!!');
          fixed.removeClass('at-bottom');
        }
      });
    });
  }
});